import React from "react";
import Add01Icon from "../../assets/icons/add-01-solid-standard";
import { useNavigate } from "react-router-dom";

interface ProgressCardProps {
  cardConfig: {
    progressFrom: string;
    progressTo: string;
    buttonLink: string;
  };
}

const ProgressCard: React.FC<ProgressCardProps> = ({ cardConfig }) => {
  const navigate = useNavigate();

  const vistButtonLink = (link: string) => {
    navigate(link);
  };

  return (
    <>
      <div className="w-full px-8 py-6 bg-white flex flex-col rounded-[2.8em]">
        <h3 className="font-grgrifter text-[1.5em] tracking-wider text-[#1B1B1B] mt-2">
          Last Logged
        </h3>

        <div className="flex justify-between items-center mt-4 ">
          {cardConfig.progressFrom === "No progress to show" ? (
            <>
              <p className="pr-4 w-[10em]">
                <span className="font-bold">{cardConfig.progressFrom}</span>
              </p>
            </>
          ) : (
            <>
              <p className="pr-4 w-[11em]">
                Completion of{" "}
                {/* <span className="font-bold">{cardConfig.progressFrom}</span> to{" "} */}
                <span className="font-bold">{cardConfig.progressTo}</span>
              </p>
            </>
          )}

          <button
            className="w-[10em] flex items-center justify-center px-4 py-5 bg-[#3A9437] rounded-[2em] cursor-pointer"
            type="submit"
            onClick={() => vistButtonLink(cardConfig.buttonLink)}
          >
            <Add01Icon size={32} className="mr-2" color="#FFF" />
            <p className="text-sm tracking-wider text-left w-[5em] text-white">
              Log New Progress
            </p>
          </button>
        </div>
      </div>
    </>
  );
};

export default ProgressCard;
